const ENTRYPOINT = ((window as any)._env_?.API_HOST || "") + "/api";
const AUTH_ENTRYPOINT = ((window as any)._env_?.API_HOST || "") + "/auth";

export { ENTRYPOINT, AUTH_ENTRYPOINT };